// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__s6JeD","body":"styles_body__3Se9X","form":"styles_form__c9jEg"};